import React, { useEffect } from "react";
import classnames from "classnames";
import { isMobile } from "react-device-detect";
import { SidebarItemWrap } from "./SidebarItemWrap";
import { ReactComponent as EmptyBreakfastIcon } from "./../../atoms/icons/empty-breakfast.svg";
import { ReactComponent as EmptyEntreeIcon } from "./../../atoms/icons/empty-dinner.svg";
import { Wrap, Breakfasts, Entrees, BreakfastsTitle, EntreesTitle, ClearAll, ItemWrap, EmptyBreakfast, EmptyEntree } from "./styles";

function SidebarMeals(props) {
  const { breakfasts, entrees } = props.selectedMeals;
  const { handleDeleteItem, sidebarStatus, limitations, selectedExclusions, selectedDiet, compactHeader, dietType, main_title, charge } =
    props;
  const wrapRef = React.createRef();
  const _mealType = typeof main_title !== "undefined" ? main_title : dietType;

  useEffect(() => {
    window.addEventListener("resize", handleSidebarMealsWrapHeight);
    if (!isMobile) {
      handleSidebarMealsWrapHeight();
    }

    return () => {
      window.removeEventListener("resize", handleSidebarMealsWrapHeight);
    };
  });

  useEffect(() => {
    if (!isMobile) {
      handleSidebarMealsWrapHeight();
    }
  });

  const handleSidebarMealsWrapHeight = () => {
    const wrapElement = wrapRef.current;
    const height = window.innerHeight - 440;
    const mobileHeight = window.innerHeight - 380;

    if (!wrapElement) return;

    if (!isMobile) {
      if (breakfasts.length <= 1 && entrees.length <= 1) {
        wrapElement.style.height = height > 0 ? height + "px" : "auto";
        wrapElement.style.maxHeight = "340px";
      } else {
        wrapElement.style.height = height > 0 ? height + "px" : "auto";
        wrapElement.style.maxHeight = "none";
      }
    } else {
      wrapElement.style.height = mobileHeight > 0 ? mobileHeight + "px" : "auto";
    }
  };

  const handleClearAll = (e, type) => {
    props.hadleClearAll(e, type);
  };
  const handleMealChange = (item) => {
    props.handleMealChange(item);
  };

  return (
    <Wrap className={classnames({ active: sidebarStatus === true }, { toggled: compactHeader === true })} ref={wrapRef}>
      {!breakfasts.length && limitations.breakfastsMinLimit > 0 && _mealType !== "Mediterranean Plan" && (
        <Breakfasts>
          <BreakfastsTitle>Breakfasts</BreakfastsTitle>
          <EmptyBreakfast>
            <EmptyBreakfastIcon />
          </EmptyBreakfast>
        </Breakfasts>
      )}
      {breakfasts.length > 0 && (
        <Breakfasts>
          <BreakfastsTitle>
            Breakfasts
            <ClearAll onClick={(e) => handleClearAll(e, "breakfasts")}>Clear All</ClearAll>
          </BreakfastsTitle>
          <ItemWrap>
            {breakfasts.map((item) => (
              <SidebarItemWrap
                key={item.id}
                item={item}
                charge={charge}
                selectedDiet={selectedDiet}
                selectedExclusions={selectedExclusions}
                handleMealChange={handleMealChange}
                handleDeleteItem={handleDeleteItem}
              />
            ))}
          </ItemWrap>
        </Breakfasts>
      )}
      {!entrees.length && limitations.entreesMinLimit > 0 && (
        <Entrees>
          <EntreesTitle>Entrées</EntreesTitle>
          <EmptyEntree>
            <EmptyEntreeIcon />
          </EmptyEntree>
        </Entrees>
      )}
      {entrees.length > 0 && (
        <Entrees>
          <EntreesTitle>
            Entrées <ClearAll onClick={(e) => handleClearAll(e, "entrees")}>Clear All</ClearAll>
          </EntreesTitle>
          <ItemWrap>
            {entrees.map((item) => (
              <SidebarItemWrap
                key={item.id}
                item={item}
                charge={charge}
                selectedDiet={selectedDiet}
                selectedExclusions={selectedExclusions}
                handleMealChange={handleMealChange}
                handleDeleteItem={handleDeleteItem}
              />
            ))}
          </ItemWrap>
        </Entrees>
      )}
    </Wrap>
  );
}

export default SidebarMeals;
